export const toNumber = (value: false | null | number | string | undefined) =>
  value ? (isNaN(+value) || !isFinite(+value) ? 0 : +value) : 0;
